var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('Password was reset.')))]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v(_vm._s(_vm.$t('Go to login page.')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }